import { render, staticRenderFns } from "./DashboardTimesheets.vue?vue&type=template&id=506bb511&scoped=true"
import script from "./DashboardTimesheets.vue?vue&type=script&lang=js"
export * from "./DashboardTimesheets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bb511",
  null
  
)

export default component.exports